import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { APP_DEFAULT_PATH } from 'config';
import { isTokenExpired } from '../utils/jwt';

// project imports
import Loadable from 'components/Loadable';

const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const ForgotPassword = Loadable(lazy(() => import('pages/auth/ForgotPassword')));
const ResetPassword = Loadable(lazy(() => import('pages/auth/ResetPassword')));
const ForgotPasswordMail = Loadable(lazy(() => import('pages/auth/CheckEmail')));
const ResetConfirmation = Loadable(lazy(() => import('pages/auth/ResetConfirmation')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: 'login',
      // If a valid (non-expired) token exists, redirect to dashboard. Otherwise show login.
      element: (
        <RedirectIfAuthenticated>
          <LoginPage />
        </RedirectIfAuthenticated>
      )
    },
    {
      path: 'forgot-password',
      element: <ForgotPassword />
    },
    {
      path: 'check-email',
      element: <ForgotPasswordMail />
    },
    {
      path: 'reset-password',
      element: <ResetPassword />
    },
    {
      path: 'reset-confirmation',
      element: <ResetConfirmation />
    }
  ]
};
// RedirectIfAuthenticated: if token exists and not expired, redirect to default app path
function RedirectIfAuthenticated({ children }) {
  const token = localStorage.getItem('token');
  if (!token) return children;
  if (!isTokenExpired(token)) {
    // token valid
    return <Navigate to={APP_DEFAULT_PATH} replace />;
  }
  // token expired or invalid: clear stored auth values and show login
  localStorage.removeItem('token');
  localStorage.removeItem('userEmail');
  localStorage.removeItem('userRole');
  localStorage.removeItem('userUsername');
  return children;
}

RedirectIfAuthenticated.propTypes = {
  children: PropTypes.node.isRequired
};

export default LoginRoutes;
